export default __webpack_public_path__ + "static/media/2076_00 drawing.8f6cc401.gif";